import TaskCard from "./taskCard";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import CreateNewTask from "./createNewTaskPopup";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityTaskForm,
  getTaskSearch,
  searchAllTasks,
  searchKey,
  SubTaskDataAdd,
} from "../../API/store/actions/tasks";
import { customStyle, styleEnd } from "../../algorithms/styleDirection";
import Titlebar from "../layout/titlebar";
import Paginate from "../layout/paginate";
import {
  englishDate,
  ScrollToTop,
  setCurrentPageandResetData,
} from "../../algorithms";
import TextInput from "../sharedComponents/inputs/textInput";
import { styleStart } from "./../../algorithms/styleDirection";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import DateInput from "../sharedComponents/datesInputs/date";
import StatusSection from "../reusableComponents/statusSection";
import Slide from "react-reveal/Slide";
import { resolver } from "../../API/middlewares/resolveRequests";
import LoadingPopup from "../layout/loadingPopup";
import { searchAllTaskStatusCount } from "./../../API/store/actions/tasks";
import Select from "react-select";
import BackIcon from "../BackIcon/BackIcon";
import MarqueeComponent from "../Marquee/Marquee";

const TasksIndex = ({ userToken }) => {
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [procAdded, setProcAdded] = useState(false);

  const param = useParams();
  const searchkey = useSelector((state) => state.tasks.searchkey);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const memberId = param.userId;
  const userId = memberId?.split("&")[0];
  const userName = memberId?.split("&")[1];
  //access level id from hom page
  const { state } = useLocation();
  const selectedAccesslevelId = state?.id;

  const routingCommunity = param.communityId;
  const routingCommunityId = routingCommunity?.split("&")[0];
  const routingCommunityName = routingCommunity?.split("&")[1];

  const { taskStatusId } = param;

  const onShow = () => {
    setShow(true);
  };

  const communityId =
    routingCommunityId && routingCommunityId !== "index"
      ? routingCommunityId
      : 0; //useSelector((state) => state.community.communityId?.id);
  const reload = useSelector((state) => state.reload.reload);
  const community = useSelector((state) => state.community.communityId);

  const renderModal = (communityTaskForm) => {
    return (
      <CreateNewTask
        communityTaskForm={communityTaskForm}
        AdminTaskMembersList={AdminTaskMembersList}
        setAdminTaskMembersList={setAdminTaskMembersList}
        TaskMembersList={TaskMembersList}
        setTaskMembersList={setTaskMembersList}
        TaskStatusDropdownList={TaskStatusDropdownList}
        setTaskStatusDropdownList={setTaskStatusDropdownList}
        PriorityDropdownList={PriorityDropdownList}
        setPriorityDropdownList={setPriorityDropdownList}
        communityId={communityId} //when we put communities
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={show}
        isActivity={false}
        onHide={() => setShow(false)}
      />
    );
  };

  const dispatch = useDispatch();
  const TasksWithProcedures = useSelector(
    (state) => state.tasks.getAllTasksWithProcedures,
  );

  const communityTaskForm = useSelector(
    (state) => state.tasks.getCommunityTaskForm,
  );

  const tasksCount = useSelector((state) => state.tasks.getAllTasksCount);

  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([]);
  const [TaskMembersList, setTaskMembersList] = useState([]);

  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState([]);
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);

  const [createContent, setCreateContent] = useState();
  const [searchText, setSearchText] = useState(searchkey);
  const [prioritySearch, setPrioritySearch] = useState(null);
  const [taskStatusSearch, setTaskStatusSearch] = useState(
    (userId && userId != "index") || routingCommunityId
      ? 0
      : (taskStatusId ?? null),
  );

  const [sharetype, setShareType] = useState(null);

  const [accessLevel, setAccessLevel] = useState(selectedAccesslevelId ?? null);
  const [membersSearch, setMembersSearch] = useState(
    userId != "index" ? userId : null,
  );
  const [communitySearch, setCommunitySearch] = useState(
    routingCommunityId ?? null,
  );
  // const [communityFlag, setCommunityFlag] = useState(0);
  // useEffect(() => {
  //   if (routingCommunityId && communityFlag == 0) {
  //     setCommunitySearch(routingCommunityId);
  //   }
  //   setCommunityFlag(1);
  // }, [routingCommunityId]);

  // const [userFlag, setUserFlag] = useState(0);
  // useEffect(() => {
  //   if (userId != "index" && userFlag == 0) {
  //     setMembersSearch(userId);
  //   }
  //   setUserFlag(1);
  // }, [userId]);
  const [classificationId, setClassificationId] = useState(0);
  useEffect(() => {
    dispatch(getCommunityTaskForm(communityId, userToken));
    dispatch(
      searchAllTasks(
        // communitySearch && communitySearch != routingCommunityId
        //   ? parseInt(communitySearch)
        //   : routingCommunityId && communitySearch == routingCommunityId
        //     ? parseInt(routingCommunityId)
        //     : communityId
        communityId ?? userId,
        currentPage,
        20,
        {
          name: searchText,
          memberId:
            userId != "index" && userId == membersSearch
              ? userId
              : membersSearch
                ? membersSearch == 0
                  ? null
                  : membersSearch
                : null,
          priorityId: prioritySearch
            ? prioritySearch == 0
              ? null
              : prioritySearch
            : null,
          taskStatusId: taskStatusSearch == 0 ? null : taskStatusSearch,
          startDate: StartDate ? englishDate(StartDate) : null,
          endDate: EndDate ? englishDate(EndDate) : null,
          accessLevelId: accessLevel == 0 ? null : accessLevel,
          classification: classificationId,
          isadmin: sharetype,
        },
        userToken,
      ),
    );
    dispatch(
      searchAllTaskStatusCount(
        communitySearch && communitySearch != routingCommunityId
          ? parseInt(communitySearch)
          : routingCommunityId && communitySearch == routingCommunityId
            ? parseInt(routingCommunityId)
            : communityId,
        // routingCommunityId ? parseInt(routingCommunityId) : communityId,
        {
          name: searchText,
          memberId:
            userId != "index" && userId == membersSearch
              ? userId
              : membersSearch
                ? membersSearch == 0
                  ? null
                  : membersSearch
                : null,
          priorityId: prioritySearch
            ? prioritySearch == 0
              ? null
              : prioritySearch
            : null,
          taskStatusId: taskStatusSearch == 0 ? null : taskStatusSearch,
          startDate: StartDate ? englishDate(StartDate) : null,
          endDate: EndDate ? englishDate(EndDate) : null,
          accessLevelId: accessLevel == 0 ? null : accessLevel,
        },
        userToken,
      ),
    );
    ScrollToTop();
  }, [
    currentPage,
    searchText,
    procAdded,
    memberId,
    userId,
    communityId,
    prioritySearch,
    taskStatusSearch,
    membersSearch,
    StartDate,
    EndDate,
    reload,
    routingCommunityId,
    routingCommunityName,
    communitySearch,
    accessLevel,
    classificationId,
    sharetype,
  ]);

  const [searchDropdowns, setSearchDrobdowns] = useState({});
  useEffect(() => {
    resolver(getTaskSearch, setSearchDrobdowns, communityId, userToken);
  }, [communityId]);

  // const [MembersList, setMembersList] = useState([]);
  // const [TaskStatusList, setTaskStatusList] = useState([]);
  // const [PriorityList, setPriorityList] = useState([]);
  // const [CommunitiesDropdownList, setCommunitiesDropdownList] = useState([]);

  // useEffect(() => {
  //   if (searchDropdowns?.data?.members)
  //     setMembersList(searchDropdowns?.data?.members);
  //   if (searchDropdowns?.data?.priorityLkp)
  //     setPriorityList(searchDropdowns?.data?.priorityLkp);
  //   if (searchDropdowns?.data?.taskStatusLkp) {
  //     setTaskStatusList(searchDropdowns?.data?.taskStatusLkp);
  //   }
  //   if (searchDropdowns?.data?.communities)
  //     setCommunitiesDropdownList(searchDropdowns?.data?.communities);
  //   console.log("4", taskStatusSearch);
  // }, [searchDropdowns]);

  let priorityList = [];
  let taskStatusList = [];
  let membersList = [];
  let communitiesList = [];
  let accesslevelList = [];
  let classification = [];

  const [showSearch, setShowSearch] = useState(false);
  if (searchDropdowns?.data?.taskStatusLkp) {
    taskStatusList = searchDropdowns?.data?.taskStatusLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    taskStatusList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.accesslevelLkp) {
    accesslevelList = searchDropdowns?.data?.accesslevelLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    accesslevelList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.priorityLkp) {
    priorityList = searchDropdowns?.data?.priorityLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    priorityList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.members) {
    membersList = searchDropdowns?.data?.members.map((item) => ({
      value: item.memberId,
      label: item.memberName,
    }));
    membersList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.communities) {
    communitiesList = searchDropdowns?.data?.communities.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    communitiesList.unshift({ value: 0, label: "الكل" });
  }
  //  console.log(tasksCount)
  if (searchDropdowns?.data && taskStatusList?.length > 1)
    return (
      <div className="d-flex flex-column w-100">
        <MarqueeComponent />
        <div
          className="ctr"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "0 20px",
            position: "relative",
            zIndex: "10",
          }}
        >
          <BackIcon />
        </div>
        {/* title */}
        <Titlebar
          title={
            Lang.tasksNavTab +
            " " +
            (userId != "index" && !taskStatusSearch
              ? routingCommunityName
                ? "التابعة الى  : " + routingCommunityName
                : "التابعة الى  : " + userName
              : "")
          }
          customImage={"/assets/images/icon1.svg"}
        />

        <StatusSection
          tasksCount={tasksCount}
          isTask={true}
          communityId={communityId}
          userToken={userToken}
        />
        <hr className="m-0" />

        <div className="d-lg-none col-12 d-flex justify-content-center align-items-center mt-4">
          {/* small screens button */}
          {community?.adminTask && (
            <CardWithTitleAndIcon
              containerStyle="d-flex justify-content-center align-items-center col-10 align-self-center"
              borderColor={"rgba(68, 68, 68, 0.25)"}
              height={90}
              width={230}
              onClick={() => {
                onShow();
              }}
              customImage={"/assets/images/Group 8273.png"}
              imgHeight={50}
              imgWidth={60}
              containerImgHeight={50}
              containerImgWidth={60}
              cardTitle={Lang.createNewTask}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
            />
          )}
          <div
            className={`d-flex col-2 justify-content-center align-items-center align-self-center my-2 my-md-0`}
            style={{ zIndex: 10 }}
            title={Lang.search}
          >
            <div
              className={`d-flex justify-content-center align-items-center  ${
                showSearch == true ? "backgroundEffect" : "bg-white"
              }`}
              style={{
                border: "1px solid rgba(199, 199, 201, 1)",
                borderRadius: "50%",
                height: 40,
                width: 40,
                marginTop: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowSearch(!showSearch);
              }}
            >
              <img
                className={`${showSearch == true ? "filterEffect" : ""}`}
                src="/assets/images/filter.svg"
                width={20}
                height={20}
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          className={`d-lg-flex d-none col justify-content-end my-2 my-md-0 ${customStyle(
            "filterIcon",
          )}`}
          style={{ zIndex: 10 }}
          title={Lang.search}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              marginTop: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>

        {/* search Input Start */}
        <Slide left opposite collapse when={showSearch}>
          <div
            className={`d-flex flex-column ${styleStart(
              "p",
              4,
              "md",
            )} justify-content-center justify-content-lg-start align-items-center align-items-lg-start mt-3 align-items-center`}
          >
            <div className="d-flex flex-lg-row flex-column col-lg-12 col-10  mb-2 ">
              <TextInput
                value={searchkey}
                iconName={"search"}
                iconSize={16}
                style={{ padding: "21.5px" }}
                iconPrefix={"fas"}
                hiddenPlaceholder={"اسم الإجراء"}
                type={"text"}
                containerStyle={"col-lg-4 col-12 "}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  setCurrentPage(1);
                  dispatch(searchKey(e.target.value));
                }}
              />

              <div
                className={`col-12 col-lg-2 besideDate ${styleEnd("p", 2, "lg")}`}
              >
                <Select
                  value={priorityList.find((e) => e.value == prioritySearch)}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setPrioritySearch(e.value);
                  }}
                  placeholder={"المدى الزمنى"}
                  className={` ${styleStart("m", 3, "xl")}`}
                  options={priorityList}
                />
              </div>
            </div>
            <div className="d-flex col-12 flex-lg-row flex-column  align-items-center align-items-xl-start mb-2">
              <div
                className={`col-10 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`}
              >
                <DateInput
                  inputStyle={"upperZIndex"}
                  placeholder={Lang.from}
                  containerStyle={`col-12 col-xl-11 ${styleStart(
                    "m",
                    5,
                    "xl",
                  )}`}
                  name={"StartDate"}
                  value={StartDate}
                  onChange={(date) => {
                    setCurrentPage(1);
                    setStartDate(date);
                  }}
                  iconPrefix="far"
                  iconName="calendar"
                  iconSize={22}
                  isClearable={true}
                />
              </div>

              <div
                className={`col-10 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`}
              >
                <div>
                  <DateInput
                    inputStyle={"upperZIndex"}
                    placeholder={Lang.to}
                    containerStyle={`col-12 col-xl-11 ${styleStart(
                      "m",
                      3,
                      "xl",
                    )}`}
                    value={EndDate}
                    onChange={(date) => {
                      setCurrentPage(1);
                      setEndDate(date);
                    }}
                    isClearable={true}
                    // value={values.EndDate}
                    // onChange={(e) => {
                    //   setFieldValue("EndDate", e);
                    //   if (values.StartDate)
                    //     if (new Date(values.StartDate) <= new Date(e)) {
                    //       setEndDateError(false);
                    //       setStartDateError(false);
                    //     } else setEndDateError(true);
                    // }}
                    iconPrefix="far"
                    iconName="calendar"
                    iconSize={22}
                  />
                </div>
                {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
              </div>
            </div>
            <div className="d-flex flex-lg-row flex-column col-lg-12 col-10 mb-2">
              <div
                className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`}
              >
                <Select
                  value={accesslevelList.find((e) => e.value === accessLevel)}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setAccessLevel(e.value);
                  }}
                  placeholder={"نوع التعاون"}
                  options={accesslevelList}
                />
              </div>
              <div
                // style={{ height: "1.5rem", zIndex: "101" }}
                className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`}
              >
                <Select
                  value={communitiesList.find(
                    (e) => e.value == communitySearch,
                  )}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setCommunitySearch(parseInt(e.value));
                  }}
                  placeholder={"المحاور"}
                  options={communitiesList}
                />
              </div>
            </div>
            <div className="d-flex flex-lg-row justify-content-start col-10 col-lg-8 flex-column px-0">
              {" "}
              <div
                className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`} // style={{ height: "1.5rem", zIndex: "101" }}
              >
                <Select
                  // value={mainEntityType.find((e) => e.value == mainType)}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setShareType(e.value);
                  }}
                  placeholder={"نوع المشاركة"}
                  options={[
                    { label: "الكل", value: undefined },
                    { label: "جهة رئيسة", value: true },
                    { label: "جهة معاونة", value: false },
                  ]}
                />
              </div>
              <div
                // style={{ height: "1.5rem", zIndex: "101" }}
                className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )} ${styleEnd("m", 2, "lg")}`}
              >
                <Select
                  value={membersList.find((e) => e.value == membersSearch)}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setMembersSearch(e.value);
                  }}
                  placeholder={"المشاركين"}
                  options={membersList}
                />
              </div>
              <div
                className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                  "p",
                  2,
                  "lg",
                )}`}
              >
                <Select
                  value={taskStatusList.find(
                    (e) => e.value == taskStatusSearch,
                  )}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setTaskStatusSearch(e.value);
                  }}
                  placeholder={Lang.taskStatus + "*"}
                  options={taskStatusList}
                />
              </div>
              <div
                className="mt-3 mx-4"
                // style={{ height: "1.5rem", zIndex: "101" }}
              >
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", cursor: "pointer" }}
                  name="classification"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setClassificationId(1);
                    } else {
                      setClassificationId(0);
                    }
                  }}
                />
                <label className="mx-2" for="classification">
                  إجراءات غير مصنفة
                </label>
              </div>
            </div>
          </div>
        </Slide>
        {searchkey ? (
          <div
            className={`d-flex ${styleStart(
              "p",
              5,
              "md",
            )} justify-content-center justify-content-lg-start mt-3 align-items-center `}
          >
            <span className=" fw-bold">نتائج البحث عن</span>: {searchkey}{" "}
          </div>
        ) : null}
        {/* search Input End */}

        {/* Cards Listing Start */}
        <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center px-">
          {/* Task Card */}
          <TaskCard
            currentPage={currentPage}
            communityId={communityId}
            userToken={userToken}
            TasksWithProcedures={TasksWithProcedures}
            communityTaskForm={communityTaskForm}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />

          {/* lg screens button */}

          <CardWithTitleAndIcon
            containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
              "createTaskButton",
            )}`}
            borderColor={"rgba(68, 68, 68, 0.25)"}
            height={180}
            width={180}
            onClick={() => {
              onShow();
              setCreateContent(communityTaskForm);
            }}
            // customImage={"/assets/images/Group 8273.png"}
            customImage={"/assets/images/add.png"}
            imgHeight={70}
            imgWidth={80}
            containerImgHeight={70}
            containerImgWidth={80}
            cardTitle={Lang.createNewTask}
            boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
          />

          {communityTaskForm?.data?.members &&
          communityTaskForm?.data?.priorityLkp &&
          communityTaskForm?.data?.taskStatusLkp
            ? renderModal(communityTaskForm?.data)
            : null}
        </div>
        {/* Cards Listing End */}
        {/* pagination */}
        {TasksWithProcedures?.count > 0 ? (
          <div className="my-3 d-flex justify-content-center col-lg-8">
            <Paginate
              pageCount={Math.ceil(TasksWithProcedures?.count / 20)}
              currentPage={currentPage}
              clearData={undefined}
              setCurrentPage={setCurrentPage}
              setCurrentPageandResetData={setCurrentPageandResetData}
            />
          </div>
        ) : null}
        {/* end agination */}
      </div>
    );
  return <LoadingPopup show={true} />;
};
export default TasksIndex;
